import React, { useState, useEffect } from "react";
import Link from "next/link";
import SmallArrow from "../../../public/static/images/svg/arrow-right.svg";

const Topics = ({ dataQuestions, topicId }) => {
  const [isSelected, setIsSelected] = useState(topicId);

  useEffect(() => {
    setIsSelected(topicId);
  });

  const questionsFiltered = dataQuestions.filter((item) => {
    return item.name != 'Kartu Kredit' && item.codename != 'kartu_kredit'
  })

  return (
    <div className="container-topic">
      <div className="title-topic">Pilih Topik</div>
      <hr className="topic-title-separator"></hr>
      <div className="container-list">
        {questionsFiltered &&
          questionsFiltered.map((i, key) => {
            const codename = i.codename.replace(/_/g, "-");
            return (
              <Link
                href="/pertanyaan-umum/[topicId]"
                as={`/pertanyaan-umum/${codename}`}
                key={key}
              >
                <a>
                  <li
                    className={
                      isSelected === codename
                        ? "topic-list topic-selected"
                        : "topic-list"
                    }
                  >
                    <div> {i.name}</div>
                    <img src={SmallArrow} alt="arrow" />
                  </li>
                  <hr className="topic-list-separator" />
                </a>
              </Link>
            );
          })}
      </div>
      <style jsx>{`
        .topic-title-separator {
          border: 1px solid var(--color-white-dark);
        }
        .topic-list-separator {
          display: none;
        }
        .container-topic {
          height: auto;
          background-color: var(--color-white-soft);
          padding: 20px;
        }
        .title-topic {
          color: var(--color-gray);
          font-size: 16px;
          font-weight: bold;
          line-height: 19px;
          padding: 5px 15px 10px 0;
        }
        .topic-list {
          color: var(--color-gray);
          list-style-type: none;
          font-size: 16px;
          word-wrap: break-word;
          padding: 5px 0;
        }
        .container-list {
          padding-top: 10px;
        }
        .topic-selected {
          font-weight: bold;
        }
        .topic-list img {
          display: none;
        }

        @media only screen and (max-width: 600px) {
          .container-topic {
            height: auto;
            background-color: var(--color-white);
            padding: 0;
          }
          .title-topic {
            display: none;
          }
          .topic-title-separator {
            display: none;
          }
          .topic-list-separator {
            display: block;
            border: 1px solid var(--color-white-soft);
          }
          li {
            font-weight: bold;
            padding: 10px 0;
            min-height: 45px;
          }
          .topic-list img {
            display: block;
          }
          .topic-list {
            display: grid;
            grid-template-columns: 11fr 1fr;
            align-items: center;
            column-gap: 5px;
          }
        }
      `}</style>
    </div>
  );
};
export default Topics;
